module.exports = __webpack_public_path__ + "img/電気回路_3_3_1.f7955821.png";